import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
	faFacebook,
	faGithub,
	faLinkedin,
	faInstagram,
	faTiktok,
	faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

import INFO from "../../data/user";

import "./styles/socials.css";

const Socials = () => {
	return (
		<div className="socials">
			{/* LinkedIn */}
			<div className="social">
				<a
					href={INFO.socials.linkedin}
					target="_blank"
					rel="noreferrer"
				>
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faLinkedin}
							className="social-icon"
						/>
					</div>
					<div className="social-text">Follow on LinkedIn</div>
				</a>
			</div>

			{/* Facebook */}
			<div className="social">
				<a
					href={INFO.socials.facebook}
					target="_blank"
					rel="noreferrer"
				>
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faFacebook}
							className="social-icon"
						/>
					</div>
					<div className="social-text">Follow on Facebook</div>
				</a>
			</div>

			{/* Instagram */}
			<div className="social">
				<a
					href={INFO.socials.instagram}
					target="_blank"
					rel="noreferrer"
				>
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faInstagram}
							className="social-icon"
						/>
					</div>
					<div className="social-text">Follow on Instagram</div>
				</a>
			</div>

			{/* TikTok */}
			<div className="social">
				<a
					href={INFO.socials.tiktok}
					target="_blank"
					rel="noreferrer"
				>
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faTiktok}
							className="social-icon"
						/>
					</div>
					<div className="social-text">Follow on TikTok</div>
				</a>
			</div>

			{/* WhatsApp */}
			<div className="social">
				<a
					href={INFO.socials.Whatsapp}
					target="_blank"
					rel="noreferrer"
				>
					<div className="social-icon">
						<FontAwesomeIcon
							icon={faWhatsapp}
							className="social-icon"
						/>
					</div>
					<div className="social-text">WhatsApp: {INFO.main.phone}</div>
				</a>
			</div>

			{/* GitHub */}
			{INFO.socials.github && (
				<div className="social">
					<a
						href={INFO.socials.github}
						target="_blank"
						rel="noreferrer"
					>
						<div className="social-icon">
							<FontAwesomeIcon
								icon={faGithub}
								className="social-icon"
							/>
						</div>
						<div className="social-text">View GitHub</div>
					</a>
				</div>
			)}

			{/* Email */}
			<div className="email">
				<div className="email-wrapper">
					<a
						href={`mailto:${INFO.main.email}`}
						target="_blank"
						rel="noreferrer"
					>
						<div className="social-icon">
							<FontAwesomeIcon
								icon={faEnvelope}
								className="social-icon"
							/>
						</div>
						<div className="social-text">
							{INFO.main.email}
						</div>
					</a>
				</div>
			</div>
		</div>
	);
};

export default Socials;